import { Stores } from "alpinejs"
import modal from "./modal"

// Proper type definition for the modal store
interface ModalStore {
  isOpen: boolean
  contentEl: Element | null
  open: (contentEl: Element) => void
  close: () => void
}

// Type for Alpine's internal properties on DOM elements
interface AlpineElement extends HTMLElement {
  __x: {
    getScope: () => {
      isMenuOpen: boolean
    }
  }
}

const search: Stores & {
  open: () => void
  close: () => void
} = {
  open() {
    document.body.style.overflow = "hidden"

    // Close mobile menu if it's open
    const headerElement = document.querySelector("header") as AlpineElement
    if (headerElement && headerElement.__x) {
      const headerScope = headerElement.__x.getScope()
      if (headerScope.isMenuOpen) {
        headerScope.isMenuOpen = false
      }
    }

    // Get the search modal template
    const searchModalTemplate = document.getElementById("search-modal-template")
    if (searchModalTemplate && window.Alpine) {
      // Get the first child of the template container, which is our actual modal content
      const modalContent = searchModalTemplate.querySelector("div")

      if (modalContent) {
        // Clone the content so we don't remove it from the template
        const clonedContent = modalContent.cloneNode(true) as HTMLElement

        // Use the modal store to open the modal with the search content
        const modalStore = window.Alpine.store("modal") as ModalStore
        modalStore.open(clonedContent)
      }
    }
  },
  close() {
    document.body.style.overflow = ""

    if (window.Alpine) {
      const modalStore = window.Alpine.store("modal") as ModalStore
      modalStore.close()
    }
  },
}

export default search
